export const content = [
  { header: 'Interwencje', email: 'naszesprawy@toya.com.pl' },
  {
    header: 'Redakcja informacji i publicystyki',
    email: 'e.grzeszczuk@toya.com.pl',
  },
  { header: 'Redakcja reportażu', email: 't.bogolebski@toya.com.pl' },
  { header: 'Redakcja programów autorskich', email: 'k.basinska@toya.com.pl' },
  { header: 'Redakcja sportowa', email: 'p.krawczyk@toya.com.pl' },
  { header: 'Dział produkcji', email: 'p.szachnowska@toya.com.pl' },
  { header: 'Dział reklamy', email: 'reklamatv@toya.com.pl' },
];
